import type {WorkloadScore} from "../../4-scoring/performScoring.ts";

/**
 * Sort workloads by execution count (most active first)
 */
export function sortByExecutionCount(workloadScores: WorkloadScore[]): WorkloadScore[] {
    return workloadScores
        .filter(ws => ws.workload.tasks.length > 0)
        .sort((a, b) => b.workload.tasks.length - a.workload.tasks.length)
}

/**
 * Sort workloads by score and execution count for recommendations
 */
export function sortByScoreAndExecution(workloadScores: WorkloadScore[], limit: number = 10): WorkloadScore[] {
    return workloadScores
        .filter(ws => ws.workload.tasks.length > 0)
        .sort((a, b) => {
            // Primary sort: score (higher is better)
            const scoreDiff = b.score.score - a.score.score
            if (Math.abs(scoreDiff) > 0.1) return scoreDiff
            // Secondary sort: execution count
            return b.workload.tasks.length - a.workload.tasks.length
        })
        .slice(0, limit)
}
